import { render, staticRenderFns } from "./section-action.vue?vue&type=template&id=4c5dbfba&scoped=true&"
import script from "./section-action.vue?vue&type=script&lang=js&"
export * from "./section-action.vue?vue&type=script&lang=js&"
import style0 from "./section-action.vue?vue&type=style&index=0&id=4c5dbfba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5dbfba",
  null
  
)

export default component.exports